var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 74,
    viewBox: "0 0 90 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5098 13.7466C22.9304 -9.97893 -14.5183 28.6055 28.5477 58.6436C30.215 59.807 32.4987 58.6686 32.5876 56.6192L32.9768 48.0719C32.9936 47.7228 32.9027 47.377 32.7166 47.0827C32.5306 46.7884 32.2586 46.5602 31.9387 46.4299C23.2346 42.9307 27.8543 24.037 35.0274 24.037C42.2004 24.037 46.8221 42.9267 38.118 46.4259C37.7982 46.5564 37.5265 46.7846 37.3406 47.0789C37.1547 47.3732 37.064 47.7189 37.0809 48.0679L37.4957 57.1939C37.5938 59.4047 38.3034 61.543 39.5435 63.3645C40.7836 65.1859 42.5043 66.617 44.5088 67.4943C48.9754 65.5159 51.4438 61.4119 51.6285 57.1188L52.0562 47.2379C52.0697 46.8809 51.972 46.5287 51.777 46.2311C51.582 45.9335 51.2995 45.7057 50.9697 45.5799C44.2816 42.9708 46.0763 31.504 48.9833 25.6089C49.407 24.7508 50.5341 24.7448 50.5341 25.5088V36.8073C50.5301 37.0782 50.6295 37.3401 50.8115 37.5385C50.9935 37.7368 51.2442 37.8562 51.511 37.8716C51.6458 37.8759 51.7801 37.8527 51.9059 37.8035C52.0317 37.7542 52.1466 37.6799 52.2435 37.5848C52.3405 37.4898 52.4177 37.376 52.4705 37.2502C52.5233 37.1244 52.5507 36.9891 52.5511 36.8524V25.6669C52.5511 24.8299 53.1743 24.0991 53.9981 24.045C54.2099 24.0306 54.4224 24.0605 54.6224 24.1327C54.8224 24.205 55.0055 24.3182 55.1606 24.4652C55.3156 24.6122 55.4392 24.7899 55.5237 24.9874C55.6081 25.1848 55.6517 25.3977 55.6516 25.6129V36.8073C55.6476 37.0782 55.747 37.3401 55.9291 37.5385C56.1111 37.7368 56.3617 37.8562 56.6285 37.8716C56.7632 37.8758 56.8974 37.8525 57.0232 37.8032C57.1489 37.7538 57.2636 37.6795 57.3604 37.5845C57.4573 37.4894 57.5344 37.3757 57.5872 37.25C57.6399 37.1242 57.6673 36.989 57.6676 36.8524V25.5168C57.6676 24.7488 58.7946 24.7548 59.2184 25.6169C62.1253 31.512 63.9201 42.9788 57.233 45.5879C56.9032 45.7137 56.6207 45.9416 56.4257 46.2391C56.2307 46.5367 56.133 46.8889 56.1465 47.2459L56.5475 56.5351C56.6364 58.5895 58.9181 59.7329 60.5904 58.5645C103.469 28.5274 66.0694 -9.95691 44.5098 13.7466Z",
    fill: "url(#paint0_linear_1631_10949)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9258 38.6543C13.6796 45.2402 19.2229 52.1445 28.5512 58.6473C30.2186 59.8107 32.5022 58.6724 32.5911 56.6229L32.9803 48.0756C32.9972 47.7265 32.9062 47.3807 32.7202 47.0864C32.5341 46.7922 32.2622 46.564 31.9422 46.4337C31.8306 46.3886 31.7229 46.3395 31.6152 46.2895C26.0048 45.8289 20.5682 44.3822 15.6008 41.4016C14.0253 40.4304 12.4706 39.5293 10.9258 38.6543Z",
    fill: "url(#paint1_linear_1631_10949)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1646 46.4105L38.1212 46.4296C37.8014 46.56 37.5296 46.7883 37.3438 47.0826C37.1579 47.3769 37.0671 47.7225 37.084 48.0715L37.4989 57.1975C37.5969 59.4084 38.3065 61.5467 39.5467 63.3681C40.7868 65.1896 42.5074 66.6207 44.5119 67.4979C48.9785 65.5195 51.4469 61.4156 51.6316 57.1224L52.0593 47.2415C52.0728 46.8846 51.9751 46.5323 51.7801 46.2348C51.5851 45.9372 51.3027 45.7094 50.9728 45.5835C50.5539 45.4209 50.153 45.2142 49.7766 44.9668C49.1257 45.141 48.459 45.2872 47.7755 45.3993C44.5949 45.9324 41.3854 46.2701 38.1646 46.4105Z",
    fill: "url(#paint2_linear_1631_10949)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8249 6.625C64.6246 9.12801 65.6223 12.3008 66.13 15.3865C67.4368 22.6713 65.7991 30.3806 61.8155 36.2006C61.9221 40.3796 60.7536 44.2102 57.2323 45.5839C56.9024 45.7097 56.62 45.9375 56.425 46.2351C56.23 46.5327 56.1323 46.8849 56.1458 47.2419L56.5468 56.531C56.6357 58.5855 58.9174 59.7289 60.5897 58.5605C92.334 36.3257 80.078 9.46041 62.8249 6.625Z",
    fill: "url(#paint3_linear_1631_10949)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1631_10949",
    x1: 56.3885,
    y1: 69.5037,
    x2: 34.2146,
    y2: -5.14943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B994E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#1E934E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#25814E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D6C4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1631_10949",
    x1: -1.57422,
    y1: 48.8806,
    x2: 40.8221,
    y2: 48.8806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D6C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008941"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1631_10949",
    x1: 41.9645,
    y1: 68.7544,
    x2: 46.1096,
    y2: 41.7064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D6C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008941"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1631_10949",
    x1: 74.7007,
    y1: 53.0508,
    x2: 50.9645,
    y2: 5.19953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D6C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008941"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.715fd177cc1f03085609fb91cce8cad7.svg";
export { ForwardRef as ReactComponent };